import type { FC } from 'react';

import { Eye as Component } from '@untitledui-pro/icons/solid/Eye';

import { BaseIcon, type IconProps } from '../../base-icon/base-icon.tsx';

export type EyeProps = IconProps;

export const Eye: FC<EyeProps> = (props) => <BaseIcon {...props} Component={Component} />;
